import React from "react";
import "./Timeline.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import SchoolIcon from "@mui/icons-material/School";
import { MdWork } from "react-icons/md";
import StarRateIcon from "@mui/icons-material/StarRate";
import { ThemeContext } from "../../Context/theme";

export const Timeline = () => {
  const [{ themename }] = React.useContext(ThemeContext);
  const [linecolor, setlinecolor] = React.useState(
    themename === "light" ? "#23283e" : "#fcfcfc"
  );

  React.useEffect(() => {
    if (themename === "dark") {
      setlinecolor("#fcfcfc");
    } else {
      setlinecolor("#23283e");
    }
  }, [themename]);
  return (
    <>
      <div className="section mainsection">
        <h2 className="section__title" data-aos="fade-right">
          Career <span className="different">Journey</span>
        </h2>
        <p className="timeline_intro" data-aos="fade-right">
          A quick story of my journey, including the skills I learned and the
          kinds of projects I built at each stage.
        </p>
        <VerticalTimeline lineColor={linecolor}>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Mar 2023 – Present"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<MdWork />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              MERN Stack Developer
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Noida, UP (On-site)
            </h4>
            <p className="timeline_company" data-aos="fade-right">
              <a
                href="https://www.spacetotech.com/"
                target="_blank"
                rel="noreferrer"
              >
                Space To Tech
              </a>
            </p>
            <p className="timeline_label" data-aos="fade-right">
              What I worked on
            </p>
            <ul className="timeline_points" data-aos="fade-right">
              <li>
                Built and maintained full-stack features across React frontend
                and Node.js backend services.
              </li>
              <li>
                Improved UI responsiveness, API integration, and bug-fixing
                workflows in production-ready modules.
              </li>
            </ul>
            <p className="timeline_label" data-aos="fade-right">
              Skills learned
            </p>
            <p className="timeline_text" data-aos="fade-right">
              React, Redux, JavaScript, Node.js, Express, MongoDB, REST APIs,
              Git, Docker, Linux, CI/CD basics, AWS deployment, and team
              collaboration.
            </p>
            <p className="timeline_label" data-aos="fade-right">
              Projects I contributed to
            </p>
            <p className="timeline_text" data-aos="fade-right">
              E-commerce modules, dashboard pages, and feature enhancements for
              business web applications.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Jul 2021 - Feb 2023"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<MdWork />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Frontend Developer
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Remote
            </h4>
            <p className="timeline_company" data-aos="fade-right">
              Aaru Softech
            </p>
            <p className="timeline_label" data-aos="fade-right">
              What I worked on
            </p>
            <ul className="timeline_points" data-aos="fade-right">
              <li>
                Developed reusable UI components and responsive pages for client
                projects.
              </li>
              <li>
                Connected frontend screens with APIs and improved user
                experience through iterative updates.
              </li>
            </ul>
            <p className="timeline_label" data-aos="fade-right">
              Skills learned
            </p>
            <p className="timeline_text" data-aos="fade-right">
              HTML, CSS, JavaScript, React, Redux, API handling, and clean UI
              development practices.
            </p>
            <p className="timeline_label" data-aos="fade-right">
              Projects I worked on
            </p>
            <p className="timeline_text" data-aos="fade-right">
              Frontend-heavy web apps focused on responsive layouts and user
              flow optimization.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            date={"Apr 2022 - Mar 2023"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Student
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Masai School (Remote)
            </h4>
            <p data-aos="fade-right">
              Joined an intensive coding bootcamp to learn full-stack development
              and DSA. Gained hands-on experience in building full-stack
              applications and collaborative development.
            </p>
            <p className="timeline_label" data-aos="fade-right">
              Skills learned
            </p>
            <p className="timeline_text" data-aos="fade-right">
              Data Structures and Algorithms, JavaScript fundamentals, React,
              Node.js, Express, MongoDB, and problem-solving through real-world
              assignments.
            </p>
            <p className="timeline_label" data-aos="fade-right">
              Practice projects
            </p>
            <p className="timeline_text" data-aos="fade-right">
              Clone projects and capstone-style full-stack applications built in
              team and individual settings.
            </p>
          </VerticalTimelineElement>
      
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Jul 2019 - Aug 2023"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              BCA
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Kanpur University
            </h4>
            <p className="timeline_label" data-aos="fade-right">
              Foundation
            </p>
            <p className="timeline_text" data-aos="fade-right">
              Built a strong base in computer fundamentals and software
              development concepts.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"March 2019"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Completed HS - Science
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Dum Dum Airport Hindi High School, Kolkata
            </h4>
            <p className="timeline_label" data-aos="fade-right">
              Starting point
            </p>
            <p className="timeline_text" data-aos="fade-right">
              Developed analytical thinking through science education and laid
              the groundwork for a technology career.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            icon={<StarRateIcon />}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
          ></VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </>
  );
};
